export const IsDefined = (input: any): boolean => input !== null && input !== undefined;

export const IsEveryDefined = (input: any[]): boolean => input.every(i => IsDefined(i));
